<template>
  <v-app>
      <div class="app">
          <div class="hero_img">
              <img src="@/assets/udeevent/ue_1.png" class="ue_1" >
                 <p class="ue2_t1">本公司2022年度桌曆贈獎活動已結束，感謝您的支持!
                  恭祝新的一年事事順心、萬事如意!</p> 
              <!-- <div class="ue_2">
                  <p class="ue2_t1">EBM 35歲！</p>
                  <p class="ue2_t2">填問券、贈 LINE PAY</p>
                  <img src="@/assets/udeevent/ue_coupon.png" class="coupon" >
              </div> -->
              <!-- <p class="ue2_t3" @click="gotoquesans">瀏覽問卷題目</p>
              <div class="left-58">
                  <p class="ue_st pt-64">**活動於每月一日凌晨0點開跑</p>
                  <p class="ue_st ptt-8">**當月前100名答題完成並留下資料，即可收到LINE PAY MONEY贈送100元（需先完成LINE PAY MONEY註冊）</p>
                  <p class="ue_st ptt-8">**每組LINE ID當月僅限參加一次</p>
                  <p class="ue_st ptt-8">**將於每月15日前完成贈禮（作業將於工作日期間進行）</p>
              </div> -->
              <!-- <div class="b_button" @click="gotoques" v-if="eventdate">
                  <p class="b_text"> 立即參加活動</p>
              </div> -->
              <!-- <div class="g_button" v-if="eventlimit">
                  <p class="g_text1"> 本月活動已結束，下一次活動將於  {{showmonth}} 月 1 日開始</p>
              </div> -->
          </div>
      </div>
  </v-app>
</template>
<script>
// import axios from 'axios'
export default {
  created(){
      // const date1 = new Date();
      // let year = date1.getFullYear();
      // let month =date1.getMonth();
      // month++;
      // this.showmonth = month+1;
      // month = ("0" + month).slice(-2);
      // let datee = date1.getDate();
      // console.log(year,month,datee);
      // let formmonth = year+ month;
      // let formData = new FormData();
      // formData.append("Month", formmonth);
      // try {
      //     axios.post('https://fhrweb.ebmtech.com/net/api/EventStatus',formData).then(response =>{
      //         if(response.data.checK_CODE =='01'){
      //             this.eventdate = true;
      //         }
      //     else if(response.data.checK_CODE =='02'){
      //         this.eventlimit = true
      //     }
      //     })
      // } 
      // catch (err) {
      //   console.log(err.response);
      // }

  },
  metaInfo() {
      return { 
          title: "UDE",
          meta: [
              { name: 'description', content:  'Server. Viewer. Display. AI All in one iPad.'},
          ]
      }
  },
  // data(){
  //     return{
  //         eventdate : false,
  //         // eventstartdate:false,
  //         eventlimit: false,
  //         showmonth:''
  //     }
  // },
  // methods:{
  //     gotoques(){
  //         this.$router.push("/udequestionform");
  //     },
  //     gotoquesans(){
  //         this.$router.push("/qna");
  //     }
  // }
}
</script>
<style scoped>
.app{
  width: 100%;
  height: 100%;
  background: black;
  text-align: center;
  color: white;
  overflow-x: hidden;
}
.hero_img {
/* The image used */
background-image: url("../assets/udeevent/udeevent_bg.png");
height: 1124px;
/* Center and scale the image nicely */
background-position: center;
background-repeat: no-repeat;
background-size: cover;

/* Needed to position the navbar */
position: relative;
}
.ue2_t1{
  padding: 43px;
font-family: HelveticaNeue LT 47 LightCn;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 41px;
}
.ue_1{
  margin-top: 258px;
}
/* .ptt-8{
  padding-top: 8px !important;
}
.left-58{
  margin:auto;
  width: 811px;
  text-align: left;
}
.ue_2{
  margin:auto;
  margin-top: 42px;
  width: 811px;
  height: 309px;
  background: rgba(255, 255, 255, 0.3);
}
.b_button{
  cursor: pointer;
  margin:auto;
  margin-top: 36px;
  width: 236px;
  height: 48px;
  background: #00BEFF;
}
.g_button{
  cursor: pointer;
  margin:auto;
  margin-top: 36px;
  width: 236px;
  height: 48px;
  background:#C4C4C4;
}
.pt-64{
  padding-top: 64px;
}
.coupon{
  padding-top: 38px;
}
.ue_st{
  font-family: HelveticaNeue LT 47 LightCn;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 14px;
}
.b_text{
  font-family: Helvetica Neue;
font-style: normal;
font-weight: bold;
font-size: 24px;
line-height: 29px;
padding-top: 10px;
color: #FFFFFF;
}
.g_text{
padding-top: 14px;
  font-family: Helvetica Neue;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 20px;
text-align: center;
}
.g_text1{
padding-top: 4px;
  font-family: Helvetica Neue;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 20px;
text-align: center;
}
.v-application p {
  margin-bottom: 0px;
}

.ue2_t2{
  padding-top: 9px;
  font-family: HelveticaNeue LT 47 LightCn;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 20px;
}
.ue2_t3{
  cursor: pointer;
  text-decoration: underline;
  padding-top: 64px;
  font-family: HelveticaNeue LT 47 LightCn;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 20px;
}
.ue2_t3:hover{
  color: #00BEFF;
} */
@media screen and (max-width: 840px) {
  .ue_2{
      margin:auto;
      margin-top: 42px;
      width: 296px;
      height: 238px;
  }
  .ue_1{
  margin-top: 75px;
  width: 253px;
}
.left-58{
  width: 296px;
  margin:auto;
  text-align: left;
}
}
</style>